import $ from "jquery";
window.$ = $;
window.jQuery = $;

console.log('jQuery loaded:', $.fn.jquery);
console.log('$ is available:', typeof $ !== 'undefined');

import Rails from "@rails/ujs";

import ClipboardJS from "clipboard";
import Sortable from 'sortablejs';
window.Sortable = Sortable; 
import Compressor from 'compressorjs';
window.Compressor = Compressor;
import 'jquery.cookie';

let flowbiteInitialized = false;

function initializeFlowbite() {
  if (window.initFlowbite) {
    window.initFlowbite();
    flowbiteInitialized = true;
  }
}

// Initialize on first load
document.addEventListener('DOMContentLoaded', initializeFlowbite);

import("../js/cms/app");

Promise.all([
  import('popper.js'),
  import('bootstrap'),
  import('flowbite'),
  import("select2/dist/js/select2.full"),
  import("jquery-ui-dist/jquery-ui.js"),
  import("cocoon-js"),
]).then(() => {
  initializeFlowbite();
  import("../js/cms/cms_twitter");
  import("../js/cms/prevent.enter");
  import("../js/gijirock/search");
});

window.whenJQueryReady = function (fn) {
  if (typeof window.$ !== 'undefined') {
    fn($);
  } else {
    setTimeout(() => window.whenJQueryReady(fn), 50);
  }
};

window.whenJQueryPluginReady = function (pluginName, fn) {
  function check() {
    if (typeof $ !== 'undefined' && $.fn && $.fn[pluginName]) fn($);
    else setTimeout(check, 50);
  }
  check();
};

Rails.start();

document.addEventListener("DOMContentLoaded", () => {
  new ClipboardJS('.btn-clipboard');
});
